"use strict";

Shopify.theme.jsShopBySlider = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsShopBySlider = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
	let $sliderDiv = $section.find('[data-slider]')
    let options = {
    	
    }
    let $slider = $sliderDiv.flickity({
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
      freeScroll: true,
      groupCells :'100%',
        draggable :true
      
    }); // Reset layout to avoid collapsing issues

    setTimeout(function () {
      $slider.flickity('resize');
    }, 500);
    document.addEventListener('load',function(){
     setTimeout(function () {
      $slider.flickity('resize');
    }, 500);
    })
    
  },
  unload: function unload($section) {

  }
};